import { CoinFlipGame } from "./Components/Games/CoinFlipGame";
import PrimeFactorDefense from "./Components/Games/PrimeFactorDefense";
import { ChompGame } from "./Components/Games/ChompGame";
import NimGame from "./Components/Games/NimGame";
import TwentyFourGame from "./Components/Games/TwentyFourGame";
import MancalaGame from "./Components/Games/MancalaGame";
import DotsAndBoxesGame from "./Components/Games/DotsAndBoxesGame";
import SimGame from "./Components/Games/SimGame";
import HexGame from "./Components/Games/HexGame";
import FifteenPuzzleGame from "./Components/Games/FifteenPuzzleGame";
import ConnectFourGame from "./Components/Games/ConnectFourGame";
import TowerOfHanoiGame from "./Components/Games/TowerOfHanoiGame";
import CrossSumsGame from "./Components/Games/CrossSumsGame";
import ArithmeticSprintGame from "./Components/Games/ArithmeticSprintGame";
import SudokuGame from "./Components/Games/SudokuGame";
import MinesweeperGame from "./Components/Games/MinesweeperGame";
import TangramGame from "./Components/Games/TangramGame";
import IsometricBuilderGame from "./Components/Games/IsometricBuilderGame";
import GoldbachsGarden from "./Components/Games/GoldbachsGarden";
import SieveSpeedrun from "./Components/Games/SieveSpeedrun";
import VennBlitz from "./Components/Games/VennBlitz";
import FunctionMachineGame from "./Components/Games/FunctionMachineGame";
import Header from "./Components/Header";
import About from "./Components/About";
import Contact from "./Components/Contact";
import ScrollToTop from "./Components/ScrollToTop";
import BrickWallGame from "./Components/Games/BrickWallGame";
import UltimateTicTacToeGame from "./Components/Games/UltimateTicTacToeGame";
import LightsOutGame from "./Components/Games/LightsOutGame";
import MastermindGame from "./Components/Games/MastermindGame";
import NonogramGame from "./Components/Games/NonogramGame";
import PatternMatchGame from "./Components/Games/PatternMatchGame";
import FourFoursGame from "./Components/Games/FourFoursGame";
import ChineseCheckersGame from "./Components/Games/ChineseCheckersGame";
import ReversiGame from "./Components/Games/ReversiGame";
import ZipGame from "./Components/Games/ZipGame";
import SpinningTableGame from "./Components/Games/SpinningTableGame";
import GameList from "./Components/GameList";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import Footer from "./Components/Footer";

// Main App Component
const MathGamesHub = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
        <Routes>
          <Route path="/" element={<GameList />} />
          <Route path="/games" element={<GameList />} />
          <Route path="/games/coin-flip" element={<CoinFlipGame />} />
          <Route path="/games/chomp" element={<ChompGame />} />
          <Route path="/games/prime-factor-defense" element={<PrimeFactorDefense />} />
          <Route path="/games/goldbachs-garden" element={<GoldbachsGarden />} />
          <Route path="/games/sieve-speedrun" element={<SieveSpeedrun />} />
          <Route path="/games/venn-blitz" element={<VennBlitz />} />
          <Route path="/games/brick-wall" element={<BrickWallGame />} />
          <Route path="/games/ultimate-tic-tac-toe" element={<UltimateTicTacToeGame />} />
          <Route path="/games/lights-out" element={<LightsOutGame />} />
          <Route path="/games/mastermind" element={<MastermindGame />} />
          <Route path="/games/nonogram" element={<NonogramGame />} />
          <Route path="/games/pattern-match" element={<PatternMatchGame />} />
          <Route path="/games/nim" element={<NimGame />} />
          <Route path="/games/twenty-four" element={<TwentyFourGame />} />
          <Route path="/games/mancala" element={<MancalaGame />} />
          <Route path="/games/dots-and-boxes" element={<DotsAndBoxesGame />} />
          <Route path="/games/sim" element={<SimGame />} />
          <Route path="/games/hex" element={<HexGame />} />
          <Route path="/games/15-puzzle" element={<FifteenPuzzleGame />} />
          <Route path="/games/connect4" element={<ConnectFourGame />} />
          <Route path="/games/hanoi" element={<TowerOfHanoiGame />} />
          <Route path="/games/cross-sums" element={<CrossSumsGame />} />
          <Route path="/games/arithmetic-sprint" element={<ArithmeticSprintGame />} />
          <Route path="/games/sudoku" element={<SudokuGame />} />
          <Route path="/games/minesweeper" element={<MinesweeperGame />} />
          <Route path="/games/tangrams" element={<TangramGame />} />
          <Route path="/games/isometric-builder" element={<IsometricBuilderGame />} />
          <Route path="/games/function-machine" element={<FunctionMachineGame />} />
          <Route path="/games/four-fours" element={<FourFoursGame />} />
          <Route path="/games/chinese-checkers" element={<ChineseCheckersGame />} />
          <Route path="/games/reversi" element={<ReversiGame />} />
          <Route path="/games/zip" element={<ZipGame />} />
          <Route path="/games/spinning-table" element={<SpinningTableGame />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function AppWrapper() {
  return (
    <Router basename="/">
      <ScrollToTop />
      <MathGamesHub />
    </Router>
  );
}

export default AppWrapper;
